var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devsignup container-fluid"},[_c('div',{},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"navbar-brand logo-size my-5",attrs:{"src":"/images/logo.png","alt":"TalentAlt"}})]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }